<template>
  <div
    ref="videoRef"
    class="w-full sm:w-[345px] flex items-center p-2 h-[76px] rounded-md cursor-pointer"
    :class="{ 'bg-[#306AFF]': activeIndex === index }"
    @click="$emit('click')"
  >
    <div class="relative flex-shrink-0 w-[106px] h-15 mr-2">
      <OImage v-if="item.videoEntry" :src="item.videoEntry.thumbnailUrl" class="w-[106px] h-15 rounded object-cover" />
      <div
        v-if="duration(item)"
        class="text-sm font-medium absolute bottom-0 left-0 px-1 h-[18px] u-center rounded-bl-md rounded-tr-md bg-black-50 text-white-90"
      >
        {{ duration(item) }}
      </div>
    </div>
    <h3
      :class="{ 'hover:text-white-90': activeIndex === index }"
      class="text-white-90 hover:text-link-primary text-13 font-semibold line-clamp-3"
    >
      {{ item.title }}
    </h3>
  </div>
</template>

<script>
import { defineComponent, ref } from '@nuxtjs/composition-api';
import { useInfiniteScroll } from '~/composables/useInfiniteScroll';
import { getFormattedTime } from '~/modules/common/utils/dateUtils';
import { OImage } from '~/modules/common/components/ui';

export default defineComponent({
  components: {
    OImage,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    activeIndex: {
      type: Number,
    },
    index: {
      type: Number,
    },
  },
  setup(props, { emit }) {
    const isSentDatalayer = ref(false);
    const duration = (article) => getFormattedTime(article.videoEntry.videoData.duration);

    const [videoRef] = useInfiniteScroll(() => {
      if (!isSentDatalayer.value) {
        emit('view', { item: props.item, position: props.index + 1 });
        isSentDatalayer.value = true;
      }
    });

    return { duration, videoRef };
  },
});
</script>
